import type { Regimen } from "@/data/meal-plan";
import { DAYS_OF_WEEK } from "@/types/meal-plan-state";
import { useWeekPlan } from "@/context/week-plan-context";
import { savePreset } from "@/lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function PresetEditor() {
  const { state, dispatch } = useWeekPlan();
  const regimens = state.regimens;

  function handleChange(day: typeof DAYS_OF_WEEK[number]["id"], regimenId: string) {
    const id = regimenId as Regimen["id"];
    dispatch({ type: "SET_PRESET", day: day, regimenId: id });
    savePreset(day, id);
  }

  return (
    <div className="rounded-lg border p-4 space-y-3">
      <h3 className="text-sm font-semibold">Régimen por día de la semana</h3>
      <p className="text-xs text-muted-foreground">
        Estos valores se aplican automáticamente al crear nuevas semanas.
      </p>
      <div className="grid gap-2">
        {DAYS_OF_WEEK.map(({ id, label }) => (
          <div key={id} className="flex items-center gap-3">
            <span className="text-sm font-medium w-10">{label}</span>
            <Select
              value={state.presets?.[id] ?? undefined}
              onValueChange={(v) => handleChange(id, v)}
            >
              <SelectTrigger size="sm" className="w-full">
                <SelectValue placeholder="Sin asignar" />
              </SelectTrigger>
              <SelectContent>
                {regimens.map((r) => (
                  <SelectItem key={r.id} value={r.id}>
                    {r.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
